import { AssetLibraryGalleryGridItemBase } from './AssetLibraryGalleryGridItemBase';
import { AssetType } from './constants';
import { useAssetLibraryItemGesturesMobile } from './hooks';
import { type AssetLibraryGalleryGridItemBranchProps } from './types';

export const AssetLibraryGalleryGridItemMobile = ({
    asset,
    isSelected,
    onClickAsset,
    onClickAssetPreview,
    onClickDownload,
    onClickOpenActions,
    onClickSelectItem,
    onOpenItem,
    t,
}: AssetLibraryGalleryGridItemBranchProps): JSX.Element => {
    const itemActions = useAssetLibraryItemGesturesMobile({
        onOpenItem,
        onTap: () => onClickAsset?.(asset),
        isAutoOpenOnTap: asset.type === AssetType.Folder,
    });

    return (
        <AssetLibraryGalleryGridItemBase
            asset={asset}
            isSelected={isSelected}
            itemActions={itemActions}
            t={t}
            onClickAssetPreview={onClickAssetPreview}
            onClickDownload={onClickDownload}
            onClickOpenActions={onClickOpenActions}
            onClickSelectItem={onClickSelectItem}
        />
    );
};

AssetLibraryGalleryGridItemMobile.displayName = 'AssetLibraryGalleryGridItemMobile';
